import { LIMITS } from '@sbg/shared/constants';

export type AttachmentProblem = 'tooBig' | 'type' | null;

/**
 * Check a chosen file against the same limits the server enforces (the server still re-checks magic bytes).
 * Kept apart from `form-schema.ts`: the form needs this on screen, and the schema (Zod) only when it validates.
 */
export function checkAttachment(file: Pick<File, 'size' | 'type'>): AttachmentProblem {
  if (!(LIMITS.upload.attachmentMimeTypes as readonly string[]).includes(file.type)) return 'type';
  if (file.size > LIMITS.upload.attachmentMaxBytes) return 'tooBig';
  return null;
}
